
import React from "react";

// Components
import { Button } from 'components/core/button';
import Markdown from 'markdown-to-jsx';
import { options } from 'mdx';

// Hooks
import { useTranslation } from 'react-i18next';
import { Gallery } from "components/tutor-form/imgs";

// Contexts

const markdown = 
`# Devenez tuteur·rice bénévole

Pour devenir tuteur·rice bénévole, veuillez répondre à ce court questionnaire afin que nous puissions effectuer un jumelage adéquat. Veuillez noter que l'implication minimale des tuteur·rices est d'octobre à avril et idéalement jusqu’à juin. Les plages horaires sont les suivantes:


|               | Midi              | Soir          | 
|---------------|-------------------|---------------|
| Vanier        | 11h30 à 12h30     | 15h45 à 20h00 |
| Camaradière   | 12h00 à 13h00     | 16h15 à 20h00 |
| Charlesbourg  | 12h15 à 13h15     | 16h30 à 20h00 |
| Roger-Comtois | 12h15 à 13h15     | 16h30 à 20h00 |
| Pointe-Lévy   | 12h15 à 13h15     | 16h30 à 20h00 |

Veuillez noter que les nouveaux tuteurs doivent suivre une **formation initiale en ligne d'environ 1 heure, sans horaire fixe, afin d’être admissible au jumelage**. Par la suite, chaque tuteur devra prendre **un court rendez-vous virtuel (10 minutes)** avec un membre de l'équipe DAM pour assurer un suivi de la compréhension.
Si vous avez des questions supplémentaires, voici quelques informations utiles qui pourront vous éclairer : <a href="https://diplomeavantlamedaille.org/site/TuteursBenevoles" target="_blank" rel="noopener noreferrer">Devenir tuteur bénévole | Diplôme Avant la Médaille | DAM</a>

Si ces informations ne sont pas suffisantes, n'hésitez pas à joindre un responsable des services à [interventions@diplomeavantlamedaille.org](mailto:interventions@diplomeavantlamedaille.org) ou en laissant un message au 418-431-0115. Il nous fera plaisir de répondre à vos questionnements!
`

export function InfoPage(){
  const {t} = useTranslation("tutor-form");
  return <div className="max-w-3xl px-4 ">
            <Gallery/>
            <Markdown options={options}>{markdown}</Markdown>
            <Button block color="black" to="general-info" className={"mt-6"} size="xl">{t("start")}</Button>
         </div>
}
